module.exports = __webpack_public_path__ + "img/Paimio_1045_20141663_3of4.acbbe2f9.jpg";